(function () {
    'use strict';

    angular
        .module('app.widgets')
        .directive('spCompareTo', spCompareTo);

    /* @ngInject */
    function spCompareTo() {
        var directive = {
            require: "ngModel",
            scope: {
                'otherModelValue': '=spCompareTo'
            },
            link: link
        };
        return directive;

        function link(scope, element, attributes, ngModel) {
            ngModel.$validators.compareTo = function (modelValue) {
                return modelValue == scope.otherModelValue;
            };

            scope.$watch("otherModelValue", function () {
                ngModel.$validate();
            });
        }
    }
})();
